<template>
  <div class="wrapper">
    <FORM  ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
    //table封装组件
    import tablePage from '../components/page/table.vue'
    import FORM from '../components/page/form.vue'
    import UPDATE from '../components/page/update.vue'
    //接口地址url的统一管理
    import URL from '@/views/mis/util/url'
    import DateUtil from '@/utils/IM/tradeDataUtil.js'
    import Qs from 'qs'
    import DATA from '@/views/mis/util/data'

    const validateOptionList = [
        {key: 0, value: window.$t("mis.vpnConfig.queryForm.optionList.any")},
        {key: 1, value: window.$t("mis.vpnConfig.queryForm.optionList.valid")},
        {key: 2, value: window.$t("mis.vpnConfig.queryForm.optionList.invalid")}
    ];
    let userInfo = {};

    export default {
        name: 'list',
        components: {
            tablePage,
            FORM,
            UPDATE
        },
        created(){},
        methods: {
            /*表格按钮点击事件*/
            bthClick (clickName, row) {
                if ('modify'== clickName){
                    this.getConfigSetting(row);
                }else if ('delete' == clickName){
                    this.$confirm(window.$t("mis.vpnConfig.messageBox.delete.message"), window.$t("mis.vpnConfig.messageBox.delete.title"), {
                        // distinguishCancelAndClose: true,
                        confirmButtonText: window.$t("mis.vpnConfig.messageBox.button.confirm"),
                        cancelButtonText: window.$t("mis.vpnConfig.messageBox.button.cancel")
                    }).then(
                        // this.deleteAppProductSubmit(row)
                        () => {
                            this.$axios.get(URL.vpnConfig.delete+"/"+row.id).then(res=> {
                                if (res.code == 0) {
                                    this.$message.success("Successfully Deleted.");
                                    this.$refs.childTable.defaultQueryData({});
                                }else{
                                    this.$message.error(res.message);
                                }
                            });
                        }
                    );
                }else if ('validate' == clickName){
                    this.validateVpnConfig(window.$t('mis.feedback.table.button.validate'), row);
                }
            },
            /*查询表单按钮点击事件*/
            formclick(clickName, data){
                if(window.$t('mis.vpnConfig.queryForm.button.query') == clickName){
                    if(data) {
                        this.queryData.node = data.node ? data.node : undefined;
                        this.queryData.domain = data.domain ? data.domain : undefined;
                        this.queryData.ip = data.ip ? data.ip : undefined;
                        this.queryData.isValid = data.isValid ? this.parseNumber2Boolean(data.isValid) : undefined; 
                    }
                    this.$refs.childTable.defaultQueryData(this.queryData);
                }else if(window.$t('mis.vpnConfig.queryForm.button.add') == clickName){
                    this.$refs.childUpdate.open();
                }else if(window.$t('mis.vpnConfig.queryForm.button.reset') == clickName){
                    this.$refs.childForm.reset();
                }
            },
            /*新增或跟提交数据触发事件*/
            submit(model){
                model.config = model.config.replaceAll('\n','<br/>');
                model.user = userInfo.displayName
                let url = '';
                let successMsg = '';
                if(model.id !== undefined) {
                    url = URL.vpnConfig.update;
                    successMsg = window.$t('mis.vpnConfig.modal.message.successUpdate');
                }else{
                    url = URL.vpnConfig.submit;
                    successMsg = window.$t('mis.vpnConfig.modal.message.successCreate');
                }
                this.$axios.post(url, Qs.stringify(model)).then((res) => {
                    if(res.code == 0) {
                        this.$refs.childUpdate.close();
                        this.$message.success(successMsg);
                        this.$refs.childTable.defaultQueryData({});
                    }else {
                        this.$refs.childUpdate.close();
                        this.$message.error(res.message);
                    }
                });
            },
            validateVpnConfig(clickName, row) {
                console.log('Validating vpn config:', row);
                let replacement = !row['isValid'] ? window.$t('mis.vpnConfig.table.button.valid') :  window.$t('mis.vpnConfig.table.button.invalid');
                let confirmMessage = window.$t('mis.vpnConfig.messageBox.validate.message').replace('{status}', replacement );
                this.$confirm(confirmMessage, window.$t('mis.vpnConfig.messageBox.validate.title'), {
                confirmButtonText: window.$t('mis.vpnConfig.messageBox.button.confirm'),
                cancelButtonText: window.$t('mis.vpnConfig.messageBox.button.cancel'),
                type: 'warning'
                }).then(() => {
                    this.$axios.get(URL.vpnConfig.validate + "/"+row['id']+"?isValid="+!row['isValid']).then(res => {
                    if (res.code == 0) {
                        let result = res.result;
                        if (result) {
                            this.$message.success(res.message);
                            this.$refs.childTable.defaultQueryData({});  
                        } else {
                            this.$message.error(res.message);
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: window.$t('mis.vpnConfig.messageBox.cancleMessage') + clickName
                    });          
                });
            },
            getConfigSetting(row) {
                let url = URL.vpnConfig.querySetting + "/" + row.id;
                this.$axios.get(url).then(res=> {
                    if (res.code == 0 && res.result != undefined) {
                        // this.$set(this.updateData.cols[4], "data", res.result.config);
                        let config = res.result.config.replaceAll('<br/>', '\n');
                        row.config = config;
                        this.$refs.childUpdate.open(row);
                    }else{
                        this.$message.error(res.message);
                    }
                });
            },
            dataChanage(url,option,suc,fail){
                this.$axios.post(url, Qs.stringify(option || {})).then(res => {
                    this.$refs.childTable.defaultGetData(this.queryData);
                    if(suc && (typeof suc == 'function')) suc(res);
                }).catch(res => {
                    if(fail && (typeof fail == 'function')) fail(res);
                })
            },
            parseNumber2Boolean(number) {
                if (number === 0) return undefined;
                if (number === 1) return true;
                if (number === 2) return false; 
            },
        },
        data () {
            return {
                deleteIds:"",
                queryData:{},
                modalValue: {
                    node:"",
                    domain:"",
                    ip:"",
                    config:"",
                    remark:"",
                },
                /*新增或更新*/
                updateData:{
                    cols:[
                        { title: "id", field: 'id',hidden: true},
                        { title: window.$t('mis.vpnConfig.modal.label.node'), field: 'node', data:'', placeholder: window.$t('mis.vpnConfig.modal.placeholder.node'), required:true},
                        { title: window.$t('mis.vpnConfig.modal.label.domain'), field: 'domain', data:'', placeholder: window.$t('mis.vpnConfig.modal.placeholder.domain'), required:true},
                        { title: window.$t('mis.vpnConfig.modal.label.ip'), field: 'ip', data:'', placeholder: window.$t('mis.vpnConfig.modal.placeholder.ip'), required:true},
                        { title: window.$t('mis.vpnConfig.modal.label.config'), field: 'config', data:'', placeholder: window.$t('mis.vpnConfig.modal.placeholder.config'), required:true, type: 1, textType:'textarea'},
                        { title: window.$t('mis.vpnConfig.modal.label.remark'), field: 'remark', data:'', placeholder: window.$t('mis.vpnConfig.modal.placeholder.remark'), required:false},
                    ],
                },
                /*from查询表单*/
                formData:{
                    hasLable: true,
                    cols:[
                        { title: window.$t('mis.vpnConfig.queryForm.label.node'), field: 'node', placeholder: window.$t('mis.vpnConfig.queryForm.placeholder.node')},
                        { title: window.$t('mis.vpnConfig.queryForm.label.domain'), field: 'domain', placeholder: window.$t('mis.vpnConfig.queryForm.placeholder.domain')},
                        { title: window.$t('mis.vpnConfig.queryForm.label.ip'), field: 'ip', placeholder: window.$t('mis.vpnConfig.queryForm.placeholder.ip')},
                        { title: window.$t('mis.vpnConfig.queryForm.label.isValid'), field: 'isValid', placeholder: window.$t('mis.vpnConfig.queryForm.placeholder.isValid'),type:2,optionList:validateOptionList},
                        { click: window.$t('mis.vpnConfig.queryForm.button.query'), auth: "mis:vpnConfig:query"},
                        { click: window.$t('mis.vpnConfig.queryForm.button.reset')},
                        { click: window.$t('mis.vpnConfig.queryForm.button.add'), auth: "mis:vpnConfig:add"}
                    ]
                },
                /*table生成*/
                pageData: {
                    method: "post",
                    fieldTotal: "recordsFiltered",
                    fieldData: "data",
                    isShow: false,
                    queryUrl: URL.vpnConfig.query, //请求路径和参数
                    sequence: true,
                    cols: [
                        { title: window.$t('mis.vpnConfig.table.header.node'), field: 'node'},
                        { title: window.$t('mis.vpnConfig.table.header.domain'), field: 'domain'},
                        { title: window.$t('mis.vpnConfig.table.header.ip'), field: 'ip'},
                        { title: window.$t('mis.vpnConfig.table.header.remark'), field: 'remark'},
                        { title: window.$t('mis.vpnConfig.table.header.createdBy'), field: 'createdBy'},
                        { title: window.$t('mis.vpnConfig.table.header.createdAt'), field: 'createdAt'},
                        { title: window.$t('mis.vpnConfig.table.header.updatedBy'), field: 'updatedBy'},
                        { title: window.$t('mis.vpnConfig.table.header.updatedAt'), field: 'updatedAt'},
                        { title: window.$t('mis.vpnConfig.table.header.operation'), btnClick: [
                            {name: window.$t('mis.vpnConfig.table.button.valid'), click:"validate", type:'success', icon:'el-icon-check',auth:"mis:vpnConfig:validate", hidden (val, row){
                                if (row['isValid'] == true) return false;
                                else return true;
                            }},
                            {name: window.$t('mis.vpnConfig.table.button.invalid'), click:"validate", type:'warning', icon:'el-icon-close',auth:"mis:vpnConfig:validate", hidden (val, row){
                                if (row['isValid'] == true) return true;
                                else return false;
                            }},
                            {name: window.$t('mis.vpnConfig.table.button.modify'), click:"modify",type:"primary", icon: "el-icon-view", auth:"mis:vpnConfig:modify"},
                            {name: window.$t('mis.vpnConfig.table.button.delete'), click:"delete",type:"primary",icon:"el-icon-delete", auth:"mis:vpnConfig:delete"}
                        ]}
                    ]
                }
            }
        },
        mounted() {
            userInfo = DATA.base.user();
        }
    }
</script>
